import React from 'react';
import { Grid } from '../Grid';
import { Row } from '../Row';
import { Column } from '../Column';
import {
  MENU,
  MENU_FIRST_ROW,
  MENU_LOGO,
  MENU_FIRST_LEVEL,
  MENU_BUTTON,
} from '../utils/classes'
import { default as cls } from '../utils/classnames';
import { ColoredButton, Color } from '../ColoredButton'
import './_styles.scss';

export interface IButtonMenu {
  onClick: () => void,
  text: string,
  imageSrc?: string,
  color: Color
}

export interface IMenuProps {
  className?: string,
  logo: {
    imageLogo?: string,
    imageWidth?: string
  }
  buttons: [IButtonMenu],
  menu?: React.ReactNode;
}


export const Menu = ({
                       className,
                       buttons,
                       menu,
                       logo: { imageLogo = '', imageWidth = '0px' } = {}
                     }: IMenuProps) => {
  return (
    <Grid className={cls(`${MENU}`, `${className}`)}>
      <Row className={`${MENU_FIRST_ROW}`}>
        <Column className={`${MENU_LOGO}`}>
          <img width={imageWidth} src={imageLogo} alt="claroTv logo" />
        </Column>
        <Column className={`${MENU_FIRST_LEVEL}`}>
          {menu}
        </Column>
        {
          buttons.length > 0 ?
            <Column className={`${MENU_BUTTON} header-btn-filter`}>
              {
                buttons.map((button) => {
                    return (
                      <ColoredButton
                        onClick={button.onClick}
                        children={button.text}
                        color={button.color}
                        imgSrc={button.imageSrc}
                        className='focusable'
                      />
                    )
                  }
                )
              }
            </Column>
            : null
        }
      </Row>
    </Grid>
  )
};

export default Menu;



// WEBPACK FOOTER //
// ./src/packages/components/lib/Menu/index.tsx